<div id="regions-states">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="title">REGIÕES ATENDIDAS</div>

        <fieldset class="icn-search">
          <app-autocomplete
            [placeHolder]="placeHolder"
            [notFoundText]="notFoundText"
            [searchKeyword]="searchKeywordRegion"
            [data]="autocompleteDataRegions"
            (selected)="onSelectRegions($event, true)"
            [itemTemplate]="templateRegions"
            [notFoundTemplate]="notFoundRegions"
            #autocompleteRegions
          >
          </app-autocomplete>

          <ng-template #templateRegions let-item>
            <a [innerHTML]="item.dsRegiao"></a>
          </ng-template>

          <ng-template #notFoundRegions let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </fieldset>
      </div>

      <div class="col">
        <div class="title">REGIÕES SELECIONADAS</div>

        <div class="tag" *ngFor="let item of selectedRegions">
          {{ item.dsRegiao }}
          <button
            class="icn-close"
            (click)="deleteSelectRegions(item)"
          ></button>
        </div>

        <div class="no-selected" *ngIf="selectedRegions.length == 0">
          NENHUMA REGIÃO SELECIONADA
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="title">ESTADOS ATENDIDOS</div>

        <fieldset class="icn-search">
          <app-autocomplete
            [placeHolder]="placeHolder"
            [notFoundText]="notFoundText"
            [searchKeyword]="searchKeywordState"
            [data]="autocompleteDataStates"
            (selected)="onSelectStates($event, true)"
            [itemTemplate]="templateStates"
            [notFoundTemplate]="notFoundStates"
            #autocompleteStates
          >
          </app-autocomplete>

          <ng-template #templateStates let-item>
            <a [innerHTML]="item.dsEstado"></a>
          </ng-template>

          <ng-template #notFoundStates let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </fieldset>
      </div>

      <div class="col">
        <div class="title">ESTADOS SELECIONADOS</div>

        <div class="tag" *ngFor="let item of selectedStates">
          {{ item.dsEstado }}
          <button class="icn-close" (click)="deleteSelectStates(item)"></button>
        </div>

        <div class="no-selected" *ngIf="selectedStates.length == 0">
          NENHUM ESTADO SELECIONADO
        </div>
      </div>
    </div>
  </div>
</div>
